import React, { useEffect, useState } from 'react';
import { Info, X, HelpCircle } from 'lucide-react';
import { KANZLEI_HINWEISE, hinweisFuer } from './hinweise';

const SPEICHER = 'kp-hinweise-aus';
const lesen = () => { try { return localStorage.getItem(SPEICHER) === '1'; } catch { return false; } };
const EVENT = 'kp-hinweis-umschalten';
const useHinweisAus = () => {
  const [aus, setAus] = useState(lesen);
  useEffect(() => { const f = () => setAus(lesen()); window.addEventListener(EVENT, f); return () => window.removeEventListener(EVENT, f); }, []);
  const setzen = (v) => { try { localStorage.setItem(SPEICHER, v ? '1' : '0'); } catch { /* privat */ } window.dispatchEvent(new Event(EVENT)); };
  return [aus, setzen];
};

// „?“ in der Kanzlei-Leiste: Seitenhinweise ein-/ausblenden
export const HinweisSchalter = ({ pathname }) => {
  const [aus, setzen] = useHinweisAus();
  if (!hinweisFuer(KANZLEI_HINWEISE, pathname)) return null;
  return (
    <button type="button" onClick={() => setzen(!aus)} aria-pressed={!aus} aria-label="Seitenhinweise ein- oder ausblenden" data-tipp={aus ? 'Hinweis zu dieser Seite einblenden' : 'Hinweis zu dieser Seite ausblenden'} data-testid="seitenhinweis-einblenden"
      className={`shrink-0 w-9 h-9 inline-flex items-center justify-center rounded-[10px] transition-colors duration-200 ${aus ? 'text-white/70 hover:text-white hover:bg-white/10' : 'text-[#e0b56a] bg-white/10'}`}>
      <HelpCircle className="w-[18px] h-[18px]" />
    </button>
  );
};

// Hinweiszeile unter der Kanzlei-Leiste; ausblendbar, über „?“ wieder einblendbar
export const SeitenHinweis = ({ pathname }) => {
  const [aus, setzen] = useHinweisAus();
  const text = hinweisFuer(KANZLEI_HINWEISE, pathname);
  const sichtbar = !!text && !aus;
  useEffect(() => {
    document.body.style.setProperty('--kp-hinweis', sichtbar ? '34px' : '0px');
    return () => document.body.style.setProperty('--kp-hinweis', '0px');
  }, [sichtbar]);
  if (!sichtbar) return null;
  return (
    <div className="border-t border-[#e0b56a]/25 bg-[#fbf7f0]" data-testid="seitenhinweis">
      <div className="max-w-[1500px] mx-auto px-4 lg:px-8 h-[34px] flex items-center gap-2 text-[12.5px] text-[#34536b]">
        <Info className="w-3.5 h-3.5 shrink-0 text-[#b8893d]" />
        <p className="truncate flex-1" data-testid="seitenhinweis-text" data-tipp={text} tabIndex={0}>{text}</p>
        <button type="button" onClick={() => setzen(true)} aria-label="Hinweise ausblenden" data-tipp="Hinweise ausblenden (über das ? wieder einblendbar)" data-testid="seitenhinweis-ausblenden"
          className="shrink-0 w-6 h-6 inline-flex items-center justify-center rounded-md text-[#7a8a99] hover:text-[#1B3A5C] hover:bg-white transition-colors"><X className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
};
